<template>
  <div class="posts">
    <!-- <p>Posts: {{ posts }}</p> -->
    <div class="post" v-for="post in posts" v-bind:key="post.id">      
      <Post
        :userinfo="userinfo"
        :useractions="useractions"
        :post="post"
      />
    </div>
  </div>
</template>

<script>
import { db, auth } from '../db'
import Post from '@/components/Post.vue'

export default {
  name: 'Posts',
  props: [
    "userinfo",
    "useractions",
    "posts"
  ],
  components: {
    Post
  },
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.posts {
  
}
</style>
